/* Photographic product presentation: user pause, reduced motion and visibility. */
if (!customElements.get('progal-hero-video')) {
  customElements.define('progal-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion?.addEventListener('change', this.onMotion);
        this.observer?.observe(this);
        return;
      }
      this.initialized = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.video.preload = 'metadata';
      this.userPaused = false;
      this.visible = false;
      this.video.controls = false;
      this.maybePlay = () => {
        if (!this.visible || document.hidden || this.userPaused || this.motion.matches || navigator.connection?.saveData) return;
        this.video.preload = 'auto';
        this.video.play().catch(() => {});
      };
      this.onVisibility = () => document.hidden ? this.video.pause() : this.maybePlay();
      this.onMotion = () => this.motion.matches ? this.video.pause() : this.maybePlay();
      const toggle = () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.video.play().catch(() => {});
        } else {
          this.userPaused = true;
          this.video.pause();
        }
      };
      this.video.addEventListener('click', toggle);
      this.video.addEventListener('keydown', event => {
        if (event.code !== 'Space' && event.code !== 'Enter') return;
        event.preventDefault();
        toggle();
      });
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener('change', this.onMotion);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
        if (this.visible) this.maybePlay(); else this.video.pause();
      }, {threshold: [0, 0.15]});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion?.removeEventListener('change', this.onMotion);
      this.video?.pause();
    }
  });
}
